import React, { FC, PropsWithChildren } from 'react'

import './SaldoItemGroup.scss'

const SaldoItemGroup: FC<PropsWithChildren> = ({ children }) => (
    <div className="saldo-item-group">
        { children }
    </div>
)

export default SaldoItemGroup
